import React, { useMemo, useState } from "react";
import type { PageInfo } from "../../../constants/pages";
import {
  DropdownButton,
  DropdownButtonTitle,
  DropdownItem,
  DropdownNav,
} from "./HeaderMenu.styled";
import Rectangle from "../../Rectangle/Rectangle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Link } from "react-router-dom";
interface Props {
  title: string;
  items: PageInfo[];
  pathname: string;
}

const HeaderMenuDropdown: React.FC<Props> = ({ title, items, pathname }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isActive = useMemo(() => {
    return items.some((item) => item.route === pathname);
  }, [items, pathname]);

  return (
    <div>
      <DropdownButton
        variant="text"
        onClick={handleClick}
        aria-haspopup="true"
        endIcon={<KeyboardArrowDownIcon />}
      >
        <DropdownButtonTitle>
          <span>{title}</span>
          {isActive && <Rectangle width={"100%"} height={4} />}
        </DropdownButtonTitle>
      </DropdownButton>
      <DropdownNav
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {items.map((item, index) => (
          <DropdownItem key={index}>
            <Link to={item.route ?? "/"} onClick={handleClose}>
              {item.title}
            </Link>
          </DropdownItem>
        ))}
      </DropdownNav>
    </div>
  );
};

export default HeaderMenuDropdown;
